import { Component } from '@angular/core'

@Component({
  selector: 'kdgh-form-section-title',
  templateUrl: './form-section-title.component.html',
  styleUrls: ['./form-section-title.component.scss'],
})
export class FormSectionTitleComponent {}
